import postAPI from './postAPI.js'

export default async function postResendOnboardingInvite(body) {
    const data = await postAPI('admin/onboarding/invite/resend', body);
    return data;
}
